jQuery(document).foundation()

jQuery(document).ready(function () {
  // Sticky nav top
  window.onscroll = function scrollFunction() {
    if (window.pageYOffset > 0) {
      jQuery('.site-header').addClass('is-sticky');
    } else {
      jQuery('.site-header').removeClass('is-sticky');
    }
  };
  
});